export default "__VITE_ASSET__YRUo7pvN__"